<template>
  <div>
    <div class="p-5 flex flex-col">
      <p class="font-semibold text-2xl">
        {{ this.$route.meta.title }}
      </p>
      <vs-row
        vs-w="12"
        class="my-5 filter-container"
      >
        <vs-col vs-w="1">
          <p class="font-semibold">
            Filter
          </p>
        </vs-col>
        <vs-col vs-w="3" />
        <vs-col vs-w="2">
          <select-with-multiple
            v-model="filters.owner_name"
            placeholder="Select Owner Name"
            class="px-2"
            value="text"
            :options="options.owner"
          />
        </vs-col>
        <vs-col vs-w="2">
          <select-with-search
            v-model="filters.route"
            placeholder="Select Route Name"
            class="px-2"
            :options="options.route"
          />
        </vs-col>
        <vs-col vs-w="1.5">
          <date-picker
            v-model="filters.month"
            :format="'MMM'"
            type="month"
            value-type="M"
            placeholder="Month"
            class="px-2"
          />
        </vs-col>
        <vs-col vs-w="1.5">
          <date-picker
            v-model="filters.year"
            :format="'YYYY'"
            type="year"
            value-type="YYYY"
            placeholder="Year"
            class="px-2"
          />
        </vs-col>
        <vs-col
          vs-w="1"
          class="flex flex-col justify-center"
        >
          <vs-button
            type="border"
            color="primary"
            class="self-center font-semibold"
            style="min-width: 100px;"
            @click="resetFilters"
          >
            Reset
          </vs-button>
        </vs-col>
      </vs-row>
      <vs-row
        vs-w="12"
        class="mb-4"
      >
        <vs-col
          vs-w="2"
          class="flex flex-col h-full pr-2"
        >
          <div class="card metric-card flex-1 mb-2">
            <p class="font-semibold mb-2">
              Incident Rate Utilization
            </p>
            <vs-progress
              v-if="isBusy"
              indeterminate
              color="primary"
            >
              primary
            </vs-progress>
            <p
              v-else
              class="metric-value text-green-500"
            >
              {{ metrics.incidentRateUtilization }} <span class="text-black text-lg font-normal">%</span>
            </p>
          </div>
          <div class="card metric-card flex-1">
            <p class="font-semibold mb-2">
              Target
            </p>
            <vs-progress
              v-if="isBusy"
              indeterminate
              color="primary"
            >
              primary
            </vs-progress>
            <p
              v-else
              class="metric-value"
            >
              {{ metrics.target }} <span class="text-black text-lg font-normal">%</span>
            </p>
          </div>
        </vs-col>
        <vs-col
          vs-w="10"
          class="flex flex-col"
        >
          <div class="flex">
            <div class="card metric-card bg-blue-200 flex-1 mr-2 mb-2">
              <p class="font-semibold">
                Total Service Trips
              </p>
              <vs-progress
                v-if="isBusy"
                indeterminate
                color="primary"
              >
                primary
              </vs-progress>
              <p
                v-if="!isBusy"
                class="metric-value"
              >
                {{ metrics.totalServiceTrips }}
              </p>
              <p
                v-if="!isBusy"
                class="metric-label"
              >
                Service Trips
              </p>
            </div>
            <div class="card metric-card bg-green-200 flex-1 mb-2">
              <p class="font-semibold">
                Completed
              </p>
              <vs-progress
                v-if="isBusy"
                indeterminate
                color="primary"
              >
                primary
              </vs-progress>
              <p
                v-if="!isBusy"
                class="metric-value"
              >
                {{ metrics.completed }}
              </p>
              <p
                v-if="!isBusy"
                class="metric-label"
              >
                Service Trips
              </p>
            </div>
          </div>
          <div class="flex">
            <div class="card metric-card bg-red-200 flex-1 mr-2">
              <p class="font-semibold">
                Breakdown
              </p>
              <vs-progress
                v-if="isBusy"
                indeterminate
                color="primary"
              >
                primary
              </vs-progress>
              <p
                v-if="!isBusy"
                class="metric-value"
              >
                {{ metrics.breakdown }}
              </p>
              <p
                v-if="!isBusy"
                class="metric-label"
              >
                Service Trips
              </p>
            </div>
            <div class="card metric-card bg-yellow-200 flex-1 mr-2">
              <p class="font-semibold">
                Docking
              </p>
              <vs-progress
                v-if="isBusy"
                indeterminate
                color="primary"
              >
                primary
              </vs-progress>
              <p
                v-if="!isBusy"
                class="metric-value"
              >
                {{ metrics.docking }}
              </p>
              <p
                v-if="!isBusy"
                class="metric-label"
              >
                Service Trips
              </p>
            </div>
          </div>
        </vs-col>
      </vs-row>
      <div class="card p-4 mb-4">
        <vs-progress
          v-if="isBusy"
          indeterminate
          color="primary"
        >
          primary
        </vs-progress>
        <IncidentBarChart
          v-else
          :labels="barChartLabels"
          :datasets="barChartDatasets"
          :options="barChartOptions"
        />
      </div>
      <div class="card p-4 mb-4">
        <vs-progress
          v-if="isBusy"
          indeterminate
          color="primary"
        >
          primary
        </vs-progress>
        <IncidentBarChart
          v-else
          :labels="ownerBarChartLabels"
          :datasets="ownerBarChartDatasets"
          :options="ownerBarChartOptions"
        />
      </div>
      <div class="flex gap-4 mb-4">
        <div class="card flex-1 p-4">
          <vs-progress
            v-if="isBusy"
            indeterminate
            color="primary"
          >
            primary
          </vs-progress>
          <HorizontalBarChart
            v-else
            :labels="top5IncidentLabels"
            :data="top5IncidentData"
            bar-color="#F65E5E"
            title="Top 5 Number of Incident"
          />
        </div>
        <div class="card flex-1 p-4">
          <vs-progress
            v-if="isBusy"
            indeterminate
            color="primary"
          >
            primary
          </vs-progress>
          <HorizontalBarChart
            v-else
            :labels="top5DowntimeLabels"
            :data="top5DowntimeData"
            bar-color="#F65E5E"
            title="Top 5 Downtime Root Cause"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import DatePicker from "@/components/datePicker";
import SelectWithMultiple from "@/components/selectWithMultiple";
import SelectWithSearch from "@/components/selectWithSearch";
import { PAGE_TITLE } from "@/fixtures/Constants";

import HorizontalBarChart from './component/HorizontalBarChart.vue';
import IncidentBarChart from './component/IncidentBarChart.vue';

export default {
  components: {
    SelectWithMultiple,
    SelectWithSearch,
    DatePicker,
    IncidentBarChart,
    HorizontalBarChart
  },
  metaInfo() {
    return {
      title: `${PAGE_TITLE} ${this.$route.meta.title}`
    }
  },
  data() {
    const currentYear = this.moment().format('YYYY')
    return {
      isBusy: true,
      filters: {
        owner_name: [],
        route: null,
        month: null,
        year: currentYear
      },
      options: {
        owner: [],
        route: [],
        horse_power: [],
        barge_size: []
      }
    }
  },
  watch: {
    filters: {
      handler(val) {
        if (val.month || val.year) {
          this.fetchOwners()
          this.fetchRoutes()
        }
        this.fetchIncidentSafetyUtilization()
      },
      deep: true
    },
    routes: {
      handler(val) {
        this.options.route = val.map(item => ({ text: item, value: item }))
      },
      immediate: true
    },
    owners: {
      handler(val) {
        this.options.owner = val.map(item => ({ text: item.owner_name, value: item.owner_name }))
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters(
      {
        incidentSafetyUtilizationData: 'IncidentSafetyUtilization/incidentSafetyUtilizationData',
        routes: 'Dashboard/routeOpt',
        owners: 'Dashboard/ownerOpt'
      }
    ),
    metrics() {
      if (!this.incidentSafetyUtilizationData) {
        return {
          totalServiceTrips: 0,
          completed: 0,
          breakdown: 0,
          repair: 0,
          docking: 0,
          offhire: 0,
          incidentRateUtilization: 0,
          target: 0
        };
      }
      
      return {
        totalServiceTrips: this.incidentSafetyUtilizationData.total_service_trips || 0,
        completed: this.incidentSafetyUtilizationData.completed || 0,
        breakdown: this.incidentSafetyUtilizationData.breakdown || 0,
        repair: this.incidentSafetyUtilizationData.repair || 0,
        docking: this.incidentSafetyUtilizationData.docking || 0,
        offhire: this.incidentSafetyUtilizationData.offhire || 0,
        incidentRateUtilization: this.incidentSafetyUtilizationData.incident_rate_utilization || 0,
        target: this.incidentSafetyUtilizationData.target || 0
      };
    },
    barChartLabels() {
      if (!this.incidentSafetyUtilizationData?.comparisons?.rank_month) {
        return [];
      }
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      return this.incidentSafetyUtilizationData.comparisons.rank_month.map(m => monthNames[m.index - 1]);
    },
    barChartDatasets() {
      if (!this.incidentSafetyUtilizationData?.comparisons?.rank_month) {
        return [];
      }
      const monthData = this.incidentSafetyUtilizationData.comparisons.rank_month;
      return [
        { label: 'Completed', data: monthData.map(m => m.completed), backgroundColor: '#4DDD6C', stack: 'Stack 0', borderRadius: 8, barThickness: 50 },
        { label: 'Breakdown', data: monthData.map(m => m.breakdown), backgroundColor: '#F65E5E', stack: 'Stack 0', borderRadius: 8, barThickness: 50 },
        { label: 'Docking', data: monthData.map(m => m.docking), backgroundColor: '#F5965B', stack: 'Stack 0', borderRadius: 8, barThickness: 50 }
      ];
    },
    barChartOptions() {
      return {
        responsive: true,
        plugins: {
          legend: { position: 'bottom' },
          title: {
            display: true,
            text: 'Incident Rate vs Number of Service Trip',
            align: 'start',
            font: { size: 18, weight: 'bold' },
            padding: { bottom: 20 }
          },
          tooltip: {
            enabled: true
          }
        },
        scales: {
          x: {
            stacked: true,
            grid: { display: false }
          },
          y: {
            stacked: true,
            title: { display: true, text: 'Frequency' },
            grid: { display: false }
          }
        }
      };
    },
    ownerBarChartLabels() {
      if (!this.incidentSafetyUtilizationData?.comparisons?.rank_owner) {
        return [];
      }
      return this.incidentSafetyUtilizationData.comparisons.rank_owner.map(m => m.index);
    },
    ownerBarChartDatasets() {
      if (!this.incidentSafetyUtilizationData?.comparisons?.rank_owner) {
        return [];
      }
      const ownerData = this.incidentSafetyUtilizationData.comparisons.rank_owner;
      return [
        { label: 'Completed', data: ownerData.map(m => m.completed), backgroundColor: '#4DDD6C', stack: 'Stack 0', borderRadius: 8, barThickness: 50 },
        { label: 'Breakdown', data: ownerData.map(m => m.breakdown), backgroundColor: '#F65E5E', stack: 'Stack 0', borderRadius: 8, barThickness: 50 },
        { label: 'Docking', data: ownerData.map(m => m.docking), backgroundColor: '#F5965B', stack: 'Stack 0', borderRadius: 8, barThickness: 50 }
      ];
    },
    ownerBarChartOptions() {
      return {
        responsive: true,
        plugins: {
          legend: { position: 'bottom' },
          title: {
            display: true,
            text: 'Owner Incident',
            align: 'start',
            font: { size: 18, weight: 'bold'},
            padding: { bottom: 20 }
          },
          tooltip: { enabled: true }
        },
        scales: {
          x: {
            stacked: true,
            grid: { display: false }
          },
          y: {
            stacked: true,
            title: { display: true, text: 'Frequency'},
            grid: { display: false }
          }
        }
      };
    },
    top5IncidentLabels() {
      if (!this.incidentSafetyUtilizationData?.ranking?.top_5_number_of_incident) {
        return [];
      }
      return this.incidentSafetyUtilizationData.ranking.top_5_number_of_incident.map(item => item.owner_name);
    },
    top5IncidentData() {
      if (!this.incidentSafetyUtilizationData?.ranking?.top_5_number_of_incident) {
        return [];
      }
      return this.incidentSafetyUtilizationData.ranking.top_5_number_of_incident.map(item => item.total);
    },
    top5DowntimeLabels() {
      if (!this.incidentSafetyUtilizationData?.ranking?.top_5_downtime_root_cause) {
        return [];
      }
      return this.incidentSafetyUtilizationData.ranking.top_5_downtime_root_cause.map(item => item.activity_name);
    },
    top5DowntimeData() {
      if (!this.incidentSafetyUtilizationData?.ranking?.top_5_downtime_root_cause) {
        return [];
      }
      return this.incidentSafetyUtilizationData.ranking.top_5_downtime_root_cause.map(item => parseInt(item.total) || 0);
    }
  },
  mounted() {
    this.fetchIncidentSafetyUtilization()
    this.fetchRoutes()
    this.fetchOwners()
  },
  methods: {
    resetFilters() {
      this.filters = {
        owner_name: [],
        route: null,
        month: null,
        year: this.moment().format('YYYY')
      }
    },
    async fetchIncidentSafetyUtilization() {
      this.isBusy = true
      try {
        const apiFilters = {
          ...this.filters,
          owner_name: this.filters.owner_name.map(item => item.value)
        }
        await this.$store.dispatch('IncidentSafetyUtilization/fetchIncidentSafetyUtilization', apiFilters)
        this.isBusy = false
      } catch (error) {
        this.isBusy = false
        this.showFailedNotification(this, 'Failed to fetch Incident Safety Utilization Data, please try again')
      }
    },
    async fetchOwners() {
      try {
        const payload = {
          month: this.filters.month ? parseInt(this.filters.month) : null,
          year: this.filters.year ? parseInt(this.filters.year) : null
        }
        await this.$store.dispatch('Dashboard/getOwnerOpt', payload)
      } catch (e) {
        this.showFailedNotification(this, 'Failed to fetch Owner, please try again')
      }
    },
    async fetchRoutes() {
      try {
        const payload = {
          month: this.filters.month ? parseInt(this.filters.month) : null,
          year: this.filters.year ? parseInt(this.filters.year) : null
        }
        await this.$store.dispatch('Dashboard/getRouteOpt', payload)
      } catch (e) {
        this.showFailedNotification(this, 'Failed to fetch Routes, please try again')
      }
    }
  }
}
</script>

<style scoped>
.filter-container {
  @apply w-full p-3 mt-5 flex flex-row items-center bg-white rounded-lg;
}

.card {
  @apply bg-white rounded-lg
}

.card.metric-card {
  @apply flex flex-col justify-center items-start p-4 rounded-lg bg-white shadow;
  min-height: 100px;
}
.metric-value {
  @apply text-4xl font-bold;
  justify-self: center;
  align-self: center;
  line-height: 1.1;
}
.metric-label {
  @apply text-sm text-gray-600;
  justify-self: center;
  align-self: center;
}
</style>
